import { Link } from 'react-router-dom';
import Card from '../ui/Card';
import EmptyState from '../ui/EmptyState';
import { StatusBadge } from '../ui/Badge';
import { IconCandidates } from '../ui/icons';

export default function RecentCandidatesTable({ candidates }) {
  return (
    <Card padded={false}>
      <div className="border-b border-gray-100 px-6 py-4">
        <h3 className="flex items-center gap-2 text-sm font-semibold text-gray-900">
          <IconCandidates className="h-4 w-4 text-gray-400" />
          Recent candidates
        </h3>
      </div>
      {candidates.length === 0 ? (
        <EmptyState title="No candidates yet." />
      ) : (
        <table className="min-w-full divide-y divide-gray-100 text-sm">
          <tbody className="divide-y divide-gray-100">
            {candidates.map((c) => (
              <tr key={c.id} className="transition-colors hover:bg-gray-50/80">
                <td className="px-6 py-3">
                  <Link to={`/candidates/${c.id}`} className="font-medium text-primary hover:underline">
                    {c.reference_no}
                  </Link>
                </td>
                <td className="px-6 py-3 text-gray-700">{c.full_name}</td>
                <td className="px-6 py-3 text-gray-500">{c.category}</td>
                <td className="px-6 py-3 text-gray-500">{c.current_step || '—'}</td>
                <td className="px-6 py-3">
                  <StatusBadge status={c.status} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Card>
  );
}
